exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_syncPanel_1YCsl5lY2Bjq8I49ib2NuN {\n  padding: 0 40px;\n}", ""]);

// Exports
exports.locals = {
	"IA_syncPanel": "IA_syncPanel_1YCsl5lY2Bjq8I49ib2NuN"
};